/* @flow */

import * as React from 'react';

import type {GetMcfxCompany_mcfxCompany_mcfxSessions as Session} from 'nutshell-graphql-types';

import {TruncatedSessionContent, SessionMetadata} from 'shells/timeline/entry/content/session';

import {TimelineEntry} from '../../../timeline/entry/timeline-entry';
import {getSessionDeviceTypeFromSessionBrowser} from '../../../timeline/helpers';

import './v1/sidebar-content.css';

type Props = {companyId: string, companyName: string, sessions: Session[]};

export function VisitorTimeline(props: Props) {
    return (
        <div styleName='timeline-container'>
            {props.sessions.map((session, index) => {
                const totalDuration = session.visits.totalDuration || 0;

                const pages = session.visits.edges.map((edge) => ({
                    id: edge.node.id,
                    path: edge.node.url.path,
                    fullyQualifiedUrl: edge.node.url.fullyQualifiedUrl,
                }));

                return (
                    <TimelineEntry
                        key={session.id}
                        id={session.id}
                        iconVariant='session'
                        entryType='Session'
                        changeType='ADDED'
                        timestamp={session.startTime}
                        actor={{__typename: 'Origin', id: props.companyId, name: props.companyName}}
                        entity={session.url}
                        numVisits={session.visits.totalCount}
                        subject={`Via ${session.source.source}`}
                        status={{primary: {level: 'info--grey', text: 'Site visit'}}}
                        content={
                            <TruncatedSessionContent
                                durationSeconds={totalDuration}
                                pages={pages}
                            />
                        }
                        metadata={
                            <SessionMetadata
                                locationSummary={session.locationSummary}
                                deviceType={getSessionDeviceTypeFromSessionBrowser(session.browser)}
                                platformType={
                                    session.browser && session.browser.platform
                                        ? session.browser.platform
                                        : undefined
                                }
                            />
                        }
                        disableComments={true}
                        disableReactions={true}
                        isLastEntry={index === props.sessions.length - 1}
                        isTimelineSmall={true}
                    />
                );
            })}
        </div>
    );
}
